import { render, staticRenderFns } from "./UserAccessPermission.vue?vue&type=template&id=7b1caf65&lang=pug"
import script from "./UserAccessPermission.vue?vue&type=script&lang=js"
export * from "./UserAccessPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1caf65')) {
      api.createRecord('7b1caf65', component.options)
    } else {
      api.reload('7b1caf65', component.options)
    }
    module.hot.accept("./UserAccessPermission.vue?vue&type=template&id=7b1caf65&lang=pug", function () {
      api.rerender('7b1caf65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tableau/UserAccessPermission.vue"
export default component.exports